import { Reveal, SectionHead } from "./Reveal";

const TILES = [
  {
    title: "Showreel — Cohort 01",
    meta: "Direction + Edit",
    img: "https://images.unsplash.com/photo-1506863530036-1efeddceb993?crop=entropy&cs=srgb&fm=jpg&q=85",
    alt: "Student showreel still, portrait in hard light",
    cls: "lg:col-span-7 h-[360px] sm:h-[480px]",
  },
  {
    title: "Pitch Deck — Beverage Brand",
    meta: "Strategy + Design",
    img: "https://images.pexels.com/photos/20874864/pexels-photo-20874864.jpeg?auto=compress&cs=tinysrgb&w=940",
    alt: "Architectural facade used in pitch deck",
    cls: "lg:col-span-5 h-[360px] sm:h-[480px]",
  },
  {
    title: "AI Concept Frames — Auto Launch",
    meta: "AI Previs",
    img: "https://images.unsplash.com/photo-1565626424178-c699f6601afd?crop=entropy&cs=srgb&fm=jpg&q=85",
    alt: "Brutalist architecture concept frame",
    cls: "lg:col-span-5 h-[320px] sm:h-[380px]",
  },
  {
    title: "Brand Film — Fashion Label",
    meta: "Full Delivery",
    img: "https://images.unsplash.com/photo-1620122303020-87ec826cf70d?crop=entropy&cs=srgb&fm=jpg&q=85",
    alt: "Fashion film still with dramatic shadow",
    cls: "lg:col-span-7 h-[320px] sm:h-[380px]",
  },
];

export const StudentWork = () => (
  <section id="work" data-testid="student-work-section" className="bg-obsidian py-28 sm:py-40">
    <div className="max-w-[1600px] mx-auto px-5 sm:px-10">
      <SectionHead num="12" eyebrow="Proof Of Work" title="Portfolio / Student Work" />
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-6">
        {TILES.map((t, i) => (
          <Reveal key={t.title} delay={(i % 2) * 0.12} className={`group ${t.cls.split(" ")[0]}`}>
            <div className={`relative overflow-hidden border border-line ${t.cls.split(" ").slice(1).join(" ")}`}>
              <img src={t.img} alt={t.alt} className="img-cine w-full h-full object-cover" />
              <div className="absolute inset-0 bg-gradient-to-t from-obsidian/90 via-transparent to-transparent" />
              <div className="absolute bottom-0 left-0 right-0 p-6">
                <span className="font-mono text-[10px] uppercase tracking-[0.3em] text-acid">{t.meta}</span>
                <p className="font-head text-lg sm:text-xl font-semibold uppercase tracking-tight text-cream mt-2">{t.title}</p>
              </div>
            </div>
          </Reveal>
        ))}
      </div>
      <Reveal className="mt-8">
        <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-dim">
          Every piece above was briefed, revised and delivered like a client job — because it was one.
        </p>
      </Reveal>
    </div>
  </section>
);
